export default "__VITE_ASSET__CIJ24_Gt__"